__turbopack_context__.v({
  "bottom": "style-module-scss-module__9AfOZW__bottom",
  "component": "style-module-scss-module__9AfOZW__component",
  "image": "style-module-scss-module__9AfOZW__image",
  "text": "style-module-scss-module__9AfOZW__text",
  "top": "style-module-scss-module__9AfOZW__top",
});
